import BkModalDataPin from './bk-modal-data-pin';
export default BkModalDataPin;
